import { useState } from 'react';
import { faqItems } from '@/mocks/categories';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider uppercase text-accent-700 bg-accent-100 rounded-full mb-3">
            Help Center
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Frequently Asked Questions About Basetao Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Quick answers to the most common questions about Basetao Spreadsheet, shipping, warehouse services, and smart shopping.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="space-y-2.5">
            {faqItems.map((item, index) => (
              <div key={index} className="bg-background-50 border border-secondary-200/60 rounded-lg overflow-hidden">
                <h3>
                  <button
                    onClick={() => toggleFAQ(index)}
                    className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-secondary-50/50 transition-colors duration-150"
                    aria-expanded={openIndex === index}
                  >
                    <span className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                      {item.question}
                    </span>
                    <i
                      className={openIndex === index ? 'ri-arrow-up-s-line text-foreground-500 flex-shrink-0 transition-transform duration-200' : 'ri-arrow-down-s-line text-foreground-500 flex-shrink-0 transition-transform duration-200'}
                    ></i>
                  </button>
                </h3>
                {openIndex === index && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}